<div class="wrapper">
  <h2 class="tac">{{'CERTIFICAR.FORALL.SELECCIONE' | translate}}</h2>
  <div>
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>{{'CERTIFICAR.FORALL.PLACEHOLDER' | translate}}</mat-label>
      <mat-select #selectSector (selectionChange)="cambiaIdioma($event);">
        <mat-option *ngFor="let idioma of idiomas; let i = index;" [value]="idioma">
          {{'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate}}
        </mat-option>
      </mat-select>
      <mat-icon matSuffix class="secondary-text">language</mat-icon>
    </mat-form-field>
  </div>

  <ng-container *ngIf="cargando; else practicasCargadas">
    <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-template #practicasCargadas>
    <ng-container *ngIf="preguntas.length > 0; else sinTraducciones">
      <div *ngFor="let practica of preguntas; last as last" fxLayout="column" fxLayoutAlign="start stretch">
        <label class="p-20">{{practica.statement1Part1}} <code>{{ practica.practicaForall }}</code> {{ practica.statement1Part2 }} <br> <code>{{ practica.description }}</code> </label>
        <mat-radio-group fxLayout="column" fxLayoutAlign="start stretch" [(ngModel)]="responses">
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.si' | translate}}</mat-radio-button>
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.no' | translate}}</mat-radio-button>
        </mat-radio-group>
        <label class="p-20">{{practica.statement2Part1}} <code>{{ practica.practicaForall }}</code> {{ practica.statement2Part2 }} <code *ngIf="instituto!='TK'">{{ nombreEmpresa }}</code> <span *ngIf="instituto!='TK'">?</span></label>
        <mat-radio-group fxLayout="column" fxLayoutAlign="start stretch" [(ngModel)]="responses">
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.casifalso' | translate}}</mat-radio-button>
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.false' | translate}}</mat-radio-button>
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.avecesfalse' | translate}}</mat-radio-button>
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.casiverdad' | translate}}</mat-radio-button>
          <mat-radio-button disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.verdad' | translate}}</mat-radio-button>
        </mat-radio-group>
        <mat-divider [inset]="false" class="mt-20" *ngIf="!last"></mat-divider>
      </div>
    </ng-container>
    <ng-template #sinTraducciones>
      <div *ngIf="nombreIdioma" class="p-20" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon class="mr-16 secondary-text">error_outline</mat-icon>
        <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
      </div>
    </ng-template>
  </ng-template>

  <!-- <div class="pt-24 pb-16" fxLayout="row" fxLayoutAlign="center center" *ngIf="questions.length == 0">
    <mat-icon class="m-0 mr-16 secondary-text">error_outline</mat-icon>
    <div class="h2 secondary-text">{{'CERTIFICAR.ADICIONALES.PREVIEW.SINPREV' | translate}}</div>
  </div>
  <div cdkDropList class="movie-list" (cdkDropListDropped)="drop($event)" *ngIf="questions.length > 0">

    <div class="movie-block" *ngFor="let question of questions" cdkDrag >
      <label id="example-radio-group-label">{{question.statement1Part1}} <code>{{ question.practicaForall }}</code> {{ question.statement1Part2 }} <br> <code>{{ question.description }}</code> </label><br>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="responses">
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.si' | translate}}</mat-radio-button>
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.no' | translate}}</mat-radio-button>
      </mat-radio-group>
      <ng-container *ngIf="instituto=='TK'">
        <label id="example-radio-group-label">{{question.statement2Part1}} <code>{{ question.practicaForall }}</code> {{ question.statement2Part2 }}</label><br>
      </ng-container>
      <ng-container *ngIf="instituto!='TK'">
        <label id="example-radio-group-label">{{question.statement2Part1}} <code>{{ question.practicaForall }}</code> {{ question.statement2Part2 }} <code>{{ nombreEmpresa }}</code></label><br>
      </ng-container>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="responses">
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.casifalso' | translate}}</mat-radio-button>
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.false' | translate}}</mat-radio-button>
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.avecesfalse' | translate}}</mat-radio-button>
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.casiverdad' | translate}}</mat-radio-button>
        <mat-radio-button  class="example-radio-button" disabled>{{'CERTIFICAR.FORALL.RESPUESTAS.'+nombreIdioma+'.verdad' | translate}}</mat-radio-button>

      </mat-radio-group>

    </div>
  </div> -->
</div>
